import React from "react";

export const Reload = ({ color = "#fff" }) => (
  <svg
    x="0"
    y="0"
    enableBackground="new 0 0 512 512"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
  >
    <path
      style={{ fill: color }}
      d="M463.702 162.655L442.491 14.164c-1.744-12.174-16.707-17.233-25.459-8.481l-30.894 30.894C346.411 12.612 301.309 0 254.932 0 115.464 0 3.491 109.16.005 248.511c-.19 7.617 5.347 14.15 12.876 15.234l59.941 8.569c8.936 1.304 17.249-5.712 17.125-15.058C88.704 165.286 162.986 90 254.932 90c22.265 0 44.267 4.526 64.6 13.183l-29.78 29.78c-8.697 8.697-3.761 23.706 8.481 25.459l148.491 21.211c9.784 1.475 18.381-7.034 16.978-16.978zM499.117 249.412l-59.897-8.555c-7.738-.98-17.124 5.651-17.124 16.143 0 90.981-74.019 165-165 165a165.207 165.207 0 01-64.306-13.052l28.828-28.828c8.697-8.697 3.761-23.706-8.481-25.459L64.646 333.435c-9.753-1.393-18.39 6.971-16.978 16.978l21.21 148.492c1.746 12.187 16.696 17.212 25.459 8.481l31.641-31.626C165.514 499.505 210.587 512 257.096 512c138.794 0 250.752-108.618 254.897-247.28.22-7.632-5.317-14.224-12.876-15.308z"
    ></path>
  </svg>
);

export const Arrow = ({ color = "#fff" }) => (
  <svg viewBox="0 0 16 9">
    <g>
      <path
        style={{ fill: color }}
        d="M12,14.59,5.71,8.31A1,1,0,1,0,4.29,9.73l7,7a1,1,0,0,0,1.42,0l7-7a1,1,0,0,0-1.42-1.42Z"
        transform="translate(-4 -8)"
      />
    </g>
  </svg>
);

export const Save = ({ color = "#fff" }) => (
  <svg
    x="0"
    y="0"
    enableBackground="new 0 0 512 512"
    version="1.1"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
  >
    <path
      style={{ fill: color }}
      d="M403.213 20H0v472h512V128.787L403.213 20zM131 50h180v100h40V50h30v130H131V50zm250 412H131V315c0-8.271 6.729-15 15-15h220c8.271 0 15 6.729 15 15v147zm101 0h-71V315c0-24.813-20.187-45-45-45H146c-24.813 0-45 20.187-45 45v147H30V50h71v160h310V70.213l71 71V462z"
    ></path>
  </svg>
);

export const Close = ({ color = "#fff" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path
      style={{ fill: color }}
      d="M512 84.853L427.148 0 256 171.147 84.853 0 0 84.853 171.147 256 0 427.147 84.853 512 256 340.853 427.148 512 512 427.147 340.853 256zm-42.425 342.294l-42.427 42.426L256 298.426 84.853 469.574l-42.426-42.426L213.574 256 42.427 84.853l42.426-42.426L256 213.574 427.148 42.427l42.427 42.426L298.427 256z"
    ></path>
  </svg>
);

export const Trash = ({ color = "#fff" }) => (
  <svg viewBox="0 0 512 512">
    <path
      style={{ fill: color }}
      d="M482 210h-39.958l1.654-30H474.5v-45c0-41.355-33.645-75-75-75h-68V0h-151v60h-68c-41.355 0-75 33.645-75 75v45h30.805l1.654 30H30v30h41.613L82.5 437.413V512h347v-74.587L440.387 240H482zM350.669 422l6.673-242h56.308l-13.346 242zm-159.327 0l-6.673-242H241v242zM271 180h56.331l-6.673 242H271zM210.5 30h91v30h-91zm-143 105c0-24.813 20.187-45 45-45h287c24.813 0 45 20.187 45 45v15h-377zm87.158 45l6.673 242h-49.635L98.35 180zM112.5 482v-30h287v30z"
    ></path>
  </svg>
);

export const Pencil = ({ color = "#fff" }) => (
  <svg viewBox="0 0 512 512">
    <path
      style={{ fill: color }}
      d="M384.721 0L61.095 323.627 0 512l188.374-61.094L512 127.279zm84.853 127.279l-42.427 42.427-84.853-84.853 42.426-42.427zM80.963 359.61l71.427 71.428-32.036 10.39-49.782-49.782zm14.501-27.925l225.617-225.618 31.82 31.82-225.618 225.617zm53.032 53.032l225.618-225.619 31.82 31.82-225.618 225.619zm-88.313 38.965l28.136 28.136-41.642 13.505z"
    ></path>
  </svg>
);

export const Student = ({ color = "#fff" }) => (
  <svg
    x="0"
    y="0"
    enableBackground="new 0 0 512 512"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
  >
    <path
      style={{ fill: color }}
      d="M420.95 299.075v-1.321l-9.426-3.771c-34.619-13.848-53.968-12.414-64.522-16.557-9.498-3.727-16.024-12.996-16.024-23.474V240.33c18.54-18.94 29.991-44.846 29.991-73.382V74.977C360.968 33.635 327.333 0 285.991 0h-59.982c-41.342 0-74.977 33.635-74.977 74.977v91.972c0 28.534 11.451 54.441 29.991 73.382v13.622c0 11.975-8.523 22.371-20.269 24.72-2.638.528-5.264 1.054-7.878 1.584-33.748 4.451-55.862 15.445-61.826 17.498v1.321c-50.476 26.019-59.982 81.211-59.982 137.792v29.991c0 24.805 20.181 44.986 44.986 44.986h32.879l2.682-1.073c44.757-17.905 94.057-18.904 138.815-1L256 512l5.569-2.228c44.757-17.905 94.057-16.905 138.815 1l2.682 1.073h32.879c24.805 0 44.986-20.181 44.986-44.986v-29.991c0-56.564-9.498-111.77-59.981-137.793zM91.05 481.853H76.055c-8.268 0-14.995-6.727-14.995-14.995v-29.991c0-8.268 6.727-14.995 14.995-14.995H91.05v59.981zm0-89.972H76.055c-4.27 0-8.397.611-12.313 1.727 4.239-29.266 13.461-47.089 27.309-58.847v57.12zm89.973-316.904c0-24.805 20.181-44.986 44.986-44.986h59.982c24.805 0 44.986 20.181 44.986 44.986v44.986c-16.537 0-29.991-13.454-29.991-29.991V74.977h-29.991v14.995c0 16.537-13.454 29.991-29.991 29.991h-59.982V74.977zm0 91.972v-16.995h59.982c17.903 0 33.987-7.894 44.986-20.371 11 12.477 27.084 20.371 44.986 20.371v16.995c0 41.342-33.635 74.977-74.977 74.977s-74.977-33.634-74.977-74.977zm59.982 308.918c-39.279-11.353-80.685-11.354-119.963-.001V318.935c10.847-3.595 23.088-6.298 36.664-9.058 27.875-3.533 56.279-.703 83.3 8.479v157.511zM256 291.842a217.205 217.205 0 00-51.411-12.133 54.973 54.973 0 005.895-18.182c13.776 6.657 29.218 10.391 45.516 10.391s31.739-3.734 45.516-10.391a54.814 54.814 0 001.363 6.718 55.096 55.096 0 004.534 11.465A217.135 217.135 0 00256 291.842zm134.959 184.025c-39.279-11.354-80.685-11.353-119.963 0v-157.51c27.017-9.18 55.416-12.011 83.286-8.481 12.039 2.445 25.148 5.257 36.678 9.101l-.001 156.89zm29.991-141.106c13.848 11.758 23.07 29.581 27.309 58.847a44.823 44.823 0 00-12.313-1.727H420.95v-57.12zm29.991 132.097c0 8.268-6.727 14.995-14.995 14.995H420.95v-59.982h14.995c8.268 0 14.995 6.727 14.995 14.995v29.992z"
    ></path>
  </svg>
);

export const Classes = ({ color = "#fff" }) => (
  <svg
    x="0"
    y="0"
    enableBackground="new 0 0 480 480"
    viewBox="0 0 480 480"
    xmlSpace="preserve"
  >
    <path
      style={{ fill: color }}
      d="M472 208.067H360a8 8 0 00-8 8v24h-19.72l-18.512-27.768A153.009 153.009 0 00286 180.955a154.766 154.766 0 00-18.328-13.248l51.36-51.36c12.034-11.884 12.155-31.274.271-43.308-11.884-12.034-31.274-12.155-43.308-.271-.092.091-.184.182-.275.275l-17.368 17.36-24 24-31.104 31.104a7.946 7.946 0 00-2.496-.76c-4.8-.448-9.672-.68-14.472-.68H96a8 8 0 00-5.656 2.344l-73.376 73.376c-12.034 11.884-12.157 31.274-.273 43.308 11.884 12.034 31.274 12.157 43.308.273l.277-.277 7.904-7.896 2.304 7.664a113.887 113.887 0 004.104 11.304l-32.24 32.24-16 16a8.086 8.086 0 00-1.928 3.128l-16 48a8 8 0 0010.104 10.128l48-16a7.998 7.998 0 003.128-1.936l16-16 27.376-27.376a112.35 112.35 0 0066.6 21.72H248a7.178 7.178 0 001.016-.208 73.955 73.955 0 0021.384 16.36 74.753 74.753 0 0033.272 7.848H352v8a8 8 0 008 8h112a8 8 0 008-8v-160a8 8 0 00-8-8zM287.032 84.347c5.72-5.708 14.984-5.699 20.693.021A14.628 14.628 0 01312 94.699a14.55 14.55 0 01-4.28 10.344L296 116.755l-20.688-20.688 11.72-11.72zM264 107.379l20.688 20.688L272 140.755l-20.688-20.688L264 107.379zM48.968 251.787c-5.72 5.708-14.984 5.699-20.693-.021A14.628 14.628 0 0124 241.435a14.55 14.55 0 014.28-10.344l71.032-71.024h86.968c.76 0 1.536.096 2.304.112l-31.896 31.888H112a8 8 0 00-5.656 2.344l-57.376 57.376zm91.72-43.72l-53.6 53.6c-.392-1.144-.904-2.272-1.248-3.424l-4.8-15.928 34.272-34.248h25.376zM59.68 353.075l-31.032 10.344 10.344-31.032 12-12a23.888 23.888 0 0120.688 20.688l-12 12zm24.96-24.96a40.243 40.243 0 00-20.688-20.688l101.696-101.696L240 131.379l20.688 20.688-80 80h-10.752c-17.58-.046-31.869 14.168-31.915 31.749a31.833 31.833 0 001.515 9.787c-.43.227-.837.495-1.216.8l-53.68 53.712zm94.992-.048a96.935 96.935 0 01-55.16-17.16l23.6-23.6a32.126 32.126 0 0021.864 8.76h49.424l18.28 32h-58.008zm172.368 24h-48.328a58.4 58.4 0 01-50.704-29.424l-22.024-38.576a8 8 0 00-6.944-4h-54.064c-8.837 0-16-7.163-16-16s7.163-16 16-16H248a8 8 0 000-16h-44.688l52.744-52.744a133.027 133.027 0 0144.4 41.848l20.888 31.336a8 8 0 006.656 3.56h24v96zm112 16h-96v-144h96v144z"
    ></path>
    <circle style={{ fill: color }} cx="416" cy="336.067" r="16"></circle>
    <path
      style={{ fill: color }}
      d="M176 400.067H8a8 8 0 000 16h168a8 8 0 000-16zM216 400.067h-8a8 8 0 000 16h8a8 8 0 000-16z"
    ></path>
  </svg>
);

// Social Icons
export const Twitter = ({ color }) => (
  <svg
    x="0px"
    y="0px"
    viewBox="0 0 21.3 17.5"
    style={{ enableBackground: "new 0 0 21.3 17.5" }}
    xmlSpace="preserve"
  >
    <path
      style={{ fillRule: "evenodd", clipRule: "evenodd", fill: `${color}` }}
      d="M6.5,13.5c-2.2-0.1-3.6-1.7-4-3c0.6,0.1,1.2,0.1,1.8-0.1c0,0,0,0,0.1,0c-1.2-0.3-2.2-0.9-2.8-2
      C1.2,7.8,1,7,1,6.2c0.6,0.3,1.2,0.5,1.9,0.5C2,6,1.4,5.2,1.2,4.1C0.9,3,1.1,1.9,1.6,0.9C4,3.7,6.9,5.2,10.5,5.4
      c0-0.2-0.1-0.3-0.1-0.5c-0.1-1,0.1-2,0.6-2.8c0.7-1.1,1.7-1.7,2.9-1.9c1.4-0.2,2.7,0.2,3.8,1.2c0.1,0.1,0.1,0.1,0.2,0.1
      c0.9-0.2,1.7-0.5,2.5-1c0,0,0,0,0.1,0c0,0,0,0,0,0c-0.3,1-1,1.8-1.8,2.3c0.8-0.1,1.6-0.3,2.4-0.6c0,0,0,0,0,0
      c-0.2,0.2-0.3,0.4-0.5,0.6c-0.5,0.6-1,1.1-1.6,1.5c0,0-0.1,0.1-0.1,0.1c0,0.6,0,1.3-0.1,1.9c-0.2,1.3-0.5,2.6-1.1,3.8
      c-0.6,1.3-1.4,2.4-2.3,3.4c-1.6,1.7-3.6,2.8-5.9,3.3c-0.8,0.2-1.6,0.3-2.4,0.3c-2.5,0.1-4.8-0.5-6.9-1.9c0,0-0.1,0-0.1-0.1
      c1.5,0.2,2.9,0,4.3-0.6C5.2,14.4,5.9,14,6.5,13.5z"
    />
  </svg>
);

export const Instagram = ({ color }) => (
  <svg
    x="0px"
    y="0px"
    viewBox="0 0 169.1 169.1"
    style={{ enableBackground: "new 0 0 169.1 169.1" }}
    xmlSpace="preserve"
  >
    <g>
      <path
        style={{ fill: `${color}` }}
        d="M122.4,0H46.7C20.9,0,0,20.9,0,46.7v75.8c0,25.7,20.9,46.7,46.7,46.7h75.8c25.7,0,46.7-20.9,46.7-46.7V46.7
              C169.1,20.9,148.1,0,122.4,0z M154.1,122.4c0,17.5-14.2,31.7-31.7,31.7H46.7c-17.5,0-31.7-14.2-31.7-31.7V46.7
              C15,29.2,29.2,15,46.7,15h75.8c17.5,0,31.7,14.2,31.7,31.7L154.1,122.4L154.1,122.4z"
      />
      <path
        style={{ fill: `${color}` }}
        d="M84.5,41C60.5,41,41,60.5,41,84.5c0,24,19.5,43.6,43.6,43.6s43.6-19.5,43.6-43.6C128.1,60.5,108.6,41,84.5,41z
              M84.5,113.1c-15.7,0-28.6-12.8-28.6-28.6C56,68.8,68.8,56,84.5,56s28.6,12.8,28.6,28.6C113.1,100.3,100.3,113.1,84.5,113.1z"
      />
      <path
        style={{ fill: `${color}` }}
        d="M129.9,28.3c-2.9,0-5.7,1.2-7.8,3.2c-2.1,2-3.2,4.9-3.2,7.8c0,2.9,1.2,5.7,3.2,7.8c2,2,4.9,3.2,7.8,3.2
              c2.9,0,5.7-1.2,7.8-3.2c2.1-2,3.2-4.9,3.2-7.8c0-2.9-1.2-5.7-3.2-7.8C135.7,29.4,132.8,28.3,129.9,28.3z"
      />
    </g>
  </svg>
);

export const Linkedin = ({ color }) => (
  <svg
    x="0px"
    y="0px"
    viewBox="0 0 18.9 18.8"
    style={{ enableBackground: "new 0 0 18.9 18.8" }}
    xmlSpace="preserve"
  >
    <g>
      <path
        style={{ fill: `${color}` }}
        d="M0.4,6.2h3.8v12.3H0.4V6.2z M2.3,0.1c1.2,0,2.2,1,2.2,2.2s-1,2.2-2.2,2.2s-2.2-1-2.2-2.2 C0.1,1.1,1.1,0.1,2.3,0.1"
      />
      <path
        style={{ fill: `${color}` }}
        d="M6.7,6.2h3.7v1.7h0.1c0.5-1,1.8-2,3.6-2c3.9,0,4.6,2.5,4.6,5.9v6.7h-3.8v-6c0-1.4,0-3.3-2-3.3 s-2.3,1.6-2.3,3.2v6.1H6.7V6.2z"
      />
    </g>
  </svg>
);

export const Facebook = ({ color }) => (
  <svg
    x="0px"
    y="0px"
    viewBox="0 0 12 22.6"
    style={{ enableBackground: "new 0 0 12 22.6" }}
    xmlSpace="preserve"
  >
    <path
      style={{ fillRule: "evenodd", clipRule: "evenodd", fill: `${color}` }}
      d="M9.4,3.9c0.7,0,1.4,0,2.1,0c0.1,0,0.2,0,0.3,0V0.4c-0.4,0-0.8-0.1-1.1-0.1c-0.7,0-1.4-0.1-2.1-0.1
      c-1.1,0-2.1,0.3-3,0.9c-1,0.7-1.6,1.8-1.8,3c-0.1,0.5-0.1,1-0.1,1.5c0,0.8,0,1.6,0,2.4v0.3H0.2v4h3.4v10h4.2v-10h3.4 c0.2-1.3,0.3-2.6,0.5-4c-0.3,0-0.5,0-0.8,0c-1,0-3.2,0-3.2,0s0-2,0-2.8C7.7,4.3,8.4,4,9.4,3.9z"
    />
  </svg>
);
